export const TIPO_COTACAO_LABELS = {
    CODIGO_ACESSO: 'Código de acesso',
    TIPO_COTACAO: 'Tipo de simulação'
};

export const TIPO_COTACAO_PLACEHOLDERS = {
    CODIGO_ACESSO: 'Digite o código de acesso',
    TIPO_COTACAO: 'Escolha um tipo de simulação'
};
